import './index.less';

export default function RemarksTip() {
    return (
        <div className="remarks-tip">
            该备注仅对
            <span className="remarks-tip-highlight">内部及供应商</span>
            后台可见，供相关人员留意，如需在专家行程单中展示提醒内容，请使用“
            <span className="remarks-tip-highlight">特别提醒</span>
            ”功能。
        </div>
    );
}
